import logger from "logger";

const defaultAccountDetail = {
  playerservername: "",
  server: "",
  tasks: [],
  autobubble: false,
  activeworldbosses: [],
  taskhistory: [],
};

const initialState = {
  user: null,
  accountdetailrow: null,
  accounts: null,
  accountdetail: defaultAccountDetail,
  isLoading: false,
  runningtasks: null,
};

export const reducer = (state = initialState, { type, payload }) => {
  logger.log("In login Reducer", type, payload);
  switch (type) {
    case "LOGIN":
      return {
        ...state,
        user: payload,
      };
    case "CLEARUSERDATA": {
      return {
        ...initialState,
      };
    }
    case "LOGOUT":
      return {
        ...initialState,
      };
    case "SETACCOUNTS":
      return {
        ...state,
        accounts: payload,
      };
    case "SETACCOUNTDETAIL":
      return {
        ...state,
        accountdetail: payload,
      };
    case "UPDATEACCOUNTDETAIL":
      return {
        ...state,
        accountdetail: { ...state.accountdetail, ...payload },
      };
    case "CLEARACCOUNTDETAIL":
      return {
        ...state,
        accountdetail: defaultAccountDetail,
      };
    case "ISLOADING":
      return {
        ...state,
        isLoading: payload,
      };
    case "SETRUNNINGTASKS":
      return {
        ...state,
        runningtasks: payload,
      };
    case "SETACCOUNTDETAILROW":
      return {
        ...state,
        accountdetailrow: payload,
      };
    default:
      return state;
  }
};
